// ESM-Huelle fuer lib/scripts/pos/components/CMP_CMessages.js (ESM-Welle 5a).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { messageboard } from './messageboard.js';

function MessageFunctions(id) {
	//this.init(POS.POSId,POS.sessions.currentSession);
	this.options = {
		isPOS: true,
		closebuttontext:'',
		tabtext_filiale: '<li><a href="#tabs-2">Filiale</a></li>',
		tabhtml_person: '<li><a href="#tabs-3">Persönlich</a></li>',
		checkbox_html: ''
	}

}

MessageFunctions.prototype = new messageboard();

MessageFunctions.prototype.queryDB = function(url,sql, callback){
	 
	 var me = this;
	 
	 var text = "Bitte Geduld! Nachrichten werden geladen!";
    POS.hourGlass.show(text, this, function(){});
  $.when(new CRunClient().sendQuery(sql, callback, "messageboard")).then(function(error) {
                if (error){
			me.doClose(me, true);
                        callback([]);

                }

        })
	
}




MessageFunctions.prototype.doClose = function(){
	$('#mbtabs').remove();
	
}

MessageFunctions.prototype.show_loading_message = function(){
				var text = "Bitte Geduld! Nachrichten werden geladen!";
                POS.hourGlass.show(text, this, function(){});
	
}


MessageFunctions.prototype.hide_loading_message = function(){
                POS.hourGlass.hide();
	
}



//# sourceURL=CMP_CMessages.js

export { MessageFunctions };
